export const agataStark = {
    'firstName': 'Agata',
    'lastName': 'Stark',
    'profession': 'Psychoterapeuta w trakcie szkolenia, psycholog diagnosta',
    'avatar': 'agata-stark.webp',
    'slug': 'psycholog-psychoterapeuta-agata-stark',
    'locations': ['torun'],
    'services': [
        ['diagnosis', 'autism'],
        ['diagnosis', 'asd'],
        ['diagnosis', 'adhd'],
        ['group', 'socialSkills'],
    ]
}